const escapeRegexp = (value) => {
  switch (value) {
    case '||':
      return '\\|\\|';
    case '&&':
      return '\\&\\&';
    case '(':
    case ')':
    case '+':
    case '-':
    case '/':
    case ':':
    case '*':
      return '\\' + value;
  }
  return value;
};

const getLexeme = (source) => {
  if (!source) {
    return false;
  }

  let tokens = [];

  const templates = {
    keyword: /^(?:AVG|MAX)\b/i,
    number: /^-?\d+(?:\.\d+)?/,
    punct: /^[.,]/,
    param: /^[0-9A-Za-z_]+/,
    blocks: /^(?:\(|\))/,
    logic: /^(?:\|\||\&\&)/,
    cmp: /^(?:<=|>=|<>|<|>|==|!=)/,
    math: /^(?:\+|\-|\:|\/|\*)/,
    space: /^\s+/,
  };


  for (const type in templates) {
    if (tokens = source.match(templates[type])) {
      return tokens.map(value => ({type, value}))[0];
    }
  }
  return false;
};

export const tokenizing = (source) => {
  const tokens = [];
  let token: any = {value: '', type: ''};
  while (token = getLexeme(source)) {
    source = source.replace(new RegExp('^' + escapeRegexp(token.value), 'i'), '').trim();
    if (token.type === 'keyword') {
      token.value = token.value.toUpperCase();
    }

    tokens.push(token);
  }
  return tokens;
};


export const parse = (tokens) => {
  const error = (msg) => {
    throw(new Error(msg));
  };
  const peek = () => tokens[0] || {};
  const get = () => tokens.shift() || null;
  const accept = (...tks) => tks.includes(peek().value);
  const acceptType = (...types) => types.includes(peek().type);


  const subExpression = () => {
    const result = [];

    if (acceptType('number', 'param')) {
      result.push(get());
    }

    if (acceptType('cmp')) {
      result.push(get());
    }

    if (acceptType('number', 'param')) {
      result.push(get());
    }
    return result.length ? result : null;
  };


  let tmp = null;
  if (accept('(')) {
    get();
    tmp = {type: 'block', items: parse(tokens)};
  } else if (accept(')')) {
    get();
    return [];
  } else {
    tmp = get();
  }

  if (tokens.length === 0) {
    return [tmp];
  }

  if (tmp === null) {
    error('Parse error at ' + tokens[0].value);
  }
  return [tmp, ...parse(tokens)];
};

export const printTree = (ast, prefix = '') => {
  if (typeof (ast) !== 'string' && ast && ast.length > 0) {
    let result = prefix;
    ast.forEach(el => result += printTree(el, prefix));
    return result;
  }

  if (ast && ast.type === 'block') {
    return (prefix + '(') + '\n' + printTree(ast.items, prefix + '  ') + '\n' + (prefix + ')');
  }

  if (ast && ast.type === 'exp') {
    return (prefix + ast.exp.map(el => el.value).join(' ')) + '\n';
  }

  if (ast && ast.type === 'logic') {
    return '\n' + (prefix + ast.value) + '\n' + prefix;
  }

  return ast ? ' ' + ast.value : '';
};

